import {inject, Injectable, signal} from '@angular/core'
import {Router} from '@angular/router'
import {HelperService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {BehaviorSubject, Observable, of} from 'rxjs'
import {LOCAL_STORAGE} from '../application/app'

const ACCESS_TOKEN_NAME = 'access-token-borgo-kyc'

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  /**
   * The access token, primarily needed for the auth interceptor,
   * Note that signal does not work due to that user self is called
   * before the value is propagated.
   */
  public accessToken$ = new BehaviorSubject<string | null>(null)

  /**
   * This is for the "user", you can add additional
   */
  public isUser$ = signal<boolean>(false)
  private readonly router = inject(Router)
  private readonly storage = inject(LOCAL_STORAGE)

  public bootstrap(storage: Storage): Observable<boolean> {
    const token = storage.getItem(ACCESS_TOKEN_NAME)
    return this.setToken(token as string)
  }

  /**
   * Called whenever we have token
   */
  public setToken(token: string): Observable<boolean> {
    const payLoad = HelperService.GetTokenPayload(token)
    if (payLoad) {
      this.accessToken$.next(token)
      this.isUser$.set(true)
      this.storage.setItem(ACCESS_TOKEN_NAME, token)
      return of(true)
    }
    /**
     * If we are called with invalid tokens we log out
     */
    this.logout()
    return of(true)
  }


  /**
   * Reset all values and go to log in.
   */
  public logout(): void {
    // This can potentially be a long list of resets...
    this.accessToken$.next(null)
    this.storage.removeItem(ACCESS_TOKEN_NAME)
    this.isUser$.set(false)
    // this.kycService.kyc = new Kyc({})
    this.router.navigate(['']).then()
  }
}
